export const ID16 = () => {
    return (
        <div>
            <h2 className="servicePage_title">РАЗРАБОТКА МОБИЛЬНЫХ РЕШЕНИЙ</h2>
            <div className="content" readonly=""><h1>Мобильная версия платформы</h1>

                <div>
                    <strong>Мобильная версия  </strong>предназначена для отладки и сборки мобильных
                    приложений, которые будут работать на устройствах с операционными системами Android, iOS
                    или Windows.
                </div>
                <div>
                    Существует три варианта мобильной версии. Каждый из этих вариантов реализует разные возможности
                    взаимодействия с информационными базами:
                </div>

                <ul>
                    <li><b>Платформа мобильного клиента</b> — позволяет собрать
                        приложение, <span>мобильный клиент</span>, которое взаимодействует с информационными базами
                        онлайн, аналогично тому, как это делают клиентские приложения настольной версии;
                    </li>
                    <li><b>Платформа мобильного клиента с автономным режимом</b> — позволяет собрать
                        приложение, <span>мобильный клиент с автономным режимом</span>,
                        которое в зависимости от наличия соединения позволяет взаимодействовать
                        с информационными базами онлайн, либо использовать для работы локальную информационную базу
                        на мобильном устройстве;
                    </li>
                    <li><b>Мобильная платформа</b> — позволяет
                        собрать <span >приложение мобильной платформы</span>, которое использует для работы только
                        локальную информационную базу на мобильном устройстве.
                    </li>
                </ul>

                <div>
                    Разработка конфигураций для мобильных устройств ведется так же, как и разработка
                    настольных приложений, с той лишь разницей, что необходимо учитывать ограничения, которые
                    накладывает мобильная версия. Текущий состав ограничений описан в документации.
                </div>

                <div>
                    Когда конфигурация готова, разработчик, используя облачный сервис сборки и публикации мобильных
                    приложений, собирает дистрибутивы мобильного приложения для операционных систем Android, iOS
                    и Windows, и публикует их в магазинах приложений.
                </div>

                <div>
                    При отсутствии Интернета сборку и публикацию мобильного приложения можно выполнить " вручную", с
                    помощью «Сборщика мобильных приложений».
                </div>

                <div>
                    Пользователь может установить мобильное приложение на свое устройство скачав его из App
                    Store, Google Play или Windows Phone Store.
                </div>
            </div>
        </div>
    )
}